// src/redux/actions/siteActions.js
//action type constant.
export const SET_SITE_LIST = 'SET_SITE_LIST'; // Why? -> Avoid typo mistakes.

export const setSiteList = (siteList) => ({
  type: SET_SITE_LIST,
  payload: siteList,
});
